export const SelectedNodesModel = Symbol.for('SelectedNodesModel');
